document.addEventListener('DOMContentLoaded', function() {
  const mq = window.matchMedia("(min-width: 768px)");

  // Track the user's chosen view so it persists across filter updates
  let userSelectedView = null;

  function initViewToggle() {
    const wrapper = document.querySelector('.collection-grid__wrapper');
    const gridContainer = document.querySelector('.collection-grid__wrapper .grid.grid--uniform');
    const toggleButtons = document.querySelectorAll('.toggle-view');
    const pageType = wrapper ? wrapper.dataset.pageType : null;

    if (!gridContainer) return;

    // If user previously selected a view, apply it (overrides server default)
    if (userSelectedView) {
      gridContainer.classList.remove('mode-grid', 'mode-list');
      gridContainer.classList.add(`mode-${userSelectedView}`);
    }

    // Check if already has mode-grid or mode-list
    let currentMode = [...gridContainer.classList].find(c => c.startsWith("mode-"));

    // If no mode set yet, assign default
    if (!currentMode) {
      let defaultView = pageType === "search" ? "grid" : "list";
      gridContainer.classList.add(`mode-${defaultView}`);
      currentMode = `mode-${defaultView}`;
    }

    // Update toggle UI
    const activeView = currentMode.replace("mode-", "");
    toggleButtons.forEach(btn => {
      btn.classList.toggle("active-toggle", btn.dataset.view === activeView);
    });

    // Add click events
    toggleButtons.forEach(button => {
      button.addEventListener('click', function() {
        const view = this.dataset.view;
        userSelectedView = view;

        // Re-query in case DOM was replaced
        const gc = document.querySelector('.collection-grid__wrapper .grid.grid--uniform');
        const btns = document.querySelectorAll('.toggle-view');
        if (!gc) return;

        gc.classList.remove('mode-grid', 'mode-list');
        gc.classList.add(`mode-${view}`);

        btns.forEach(btn => btn.classList.remove('active-toggle'));
        this.classList.add('active-toggle');
      });
    });
  }

  initViewToggle();
  mq.addEventListener("change", initViewToggle);

  // Re-initialize after AJAX filter updates replace the DOM
  document.addEventListener('on:facet-filters:updated', initViewToggle);
  document.addEventListener('collection:reloaded', initViewToggle);
});

function scrollToGroup(id) {
  var target = document.querySelector('#group-div-' + id);
  if (!target) return;

  var header = document.querySelector('.site-header');
  var headerOffset = (header ? header.offsetHeight : 0) + 20;
  var elementPosition = target.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({
    top: elementPosition - headerOffset,
    behavior: 'smooth'
  });
}

